import React, { useMemo } from 'react';
import { FreeMode, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import ArrowIcon from '../utils/icon/icon-arrow.svg';
import ProductCard from '../product-card/product-card';

const ProductRecommendations = (props) => {
  const products = useMemo(() => {
    return props.product.recommendations?.products || [];
  }, [props.product.recommendations]);

  const sectionTitle = props.product.recommendations?.title || '';
  if (!products.length) return null;

  return (
    <div
      id="product-recommendations"
      className="flex w-full flex-col items-start rounded-lg+ border border-default px-2 py-4 md:px-4 md:pb-0 md:pt-4"
    >
      <div className="mb-2 flex w-full items-center justify-between">
        {sectionTitle && <div className="heading-5">{sectionTitle}</div>}
        <div className="pdp_upsell__navigation flex items-center gap-1">
          <button className="prev flex size-7.5 items-center justify-center rounded-full border border-default p-2 hover:border-brand-tangerine [&>svg]:h-2.5 [&>svg]:w-3  [&>svg]:rotate-180">
            <ArrowIcon />
          </button>
          <button className="next flex size-7.5 items-center justify-center rounded-full border border-default p-2 transition-colors duration-300  hover:border-brand-tangerine [&>svg]:h-2.5 [&>svg]:w-3">
            <ArrowIcon />
          </button>
        </div>
      </div>

      <Swiper
        modules={[Navigation, FreeMode]}
        navigation={{
          prevEl: `#product-recommendations .pdp_upsell__navigation .prev`,
          nextEl: `#product-recommendations .pdp_upsell__navigation .next`,
          disabledClass: '!border-grey-medium',
        }}
        slidesPerView="auto"
        spaceBetween={8}
        freeMode={true}
        loop={false}
        className="!w-full"
      >
        {products.map((product) => (
          <SwiperSlide
            key={product.id}
            className="!w-[calc(50%-4px)] md:pb-4"
          >
            <ProductCard
              product={product}
              placement="upsell"
              inputPrefix={`product-recommendations-${product.id}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ProductRecommendations;
